import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e035da7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mascot-image-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "tutorial-indicator"
}

import { ref, computed, watch, onMounted } from 'vue';
import type { MascotState, PecTutorConfig } from '../types';

// Props
interface Props {
  state: MascotState;
  config: PecTutorConfig;
  hasAvailableTutorials?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MascotDisplay',
  props: {
    state: {},
    config: {},
    hasAvailableTutorials: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

// Reactive state
const showBubble = ref(false);
const bubbleText = ref('');
const bubbleType = ref<'idle' | 'greeting' | 'hint'>('idle');
const imageError = ref(false);

// Computed properties
const currentMascotImage = computed(() => {
  if (imageError.value) {
    // Fallback to a simple, colored SVG circle if images fail
    return 'data:image/svg+xml,' + encodeURIComponent(`
      <svg width="120" height="120" xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="120" fill="${props.config.theme.primaryColor}" rx="60"/>
        <circle cx="40" cy="40" r="8" fill="white"/>
        <circle cx="80" cy="40" r="8" fill="white"/>
        <path d="M 30 70 Q 60 90 90 70" stroke="white" stroke-width="4" fill="none" stroke-linecap="round"/>
        <text x="60" y="110" text-anchor="middle" fill="white" font-size="12">PecTutor</text>
      </svg>
    `);
  }
  
  // Dynamically import the mascot images
  if (props.state.current === 'tutorial') {
    return new URL('../assets/mascot-tutorial.png', import.meta.url).href;
  }
  // For all other states ('idle', 'speaking', 'listening', etc.)
  return new URL('../assets/mascot-idle.png', import.meta.url).href;
});

const animationClass = computed(() => {
  switch (props.state.current) {
    case 'speaking':
      return 'mascot-speaking';
    case 'listening':
      return 'mascot-listening';
    case 'thinking':
      return 'mascot-thinking';
    case 'tutorial':
      return 'mascot-tutorial';
    default:
      return '';
  }
});

const mascotStyles = computed(() => ({
  width: `${props.config.mascot.size.width}px`,
  height: `${props.config.mascot.size.height}px`,
  pointerEvents: 'auto',
  transform: `translate(${props.state.position.x}px, ${props.state.position.y}px)`,
  transition: `transform ${props.config.animation.mascotTransition}ms ease`,
}));

// Methods
const handleClick = () => {
  if (props.hasAvailableTutorials) {
    emit('click');
  } else {
    showGreeting();
  }
};

const handleImageError = () => {
  console.warn('PecTutor: Mascot image failed to load, using fallback SVG');
  imageError.value = true;
};

const showGreeting = () => {
  bubbleText.value = 'Oi! Eu sou o PecTutor 👋';
  bubbleType.value = 'greeting';
  showBubble.value = true;
  
  setTimeout(() => {
    showBubble.value = false;
  }, 2000);
};

const showHint = () => {
  if (props.hasAvailableTutorials) {
    bubbleText.value = 'Clique em mim para tutoriais!';
    bubbleType.value = 'hint';
    showBubble.value = true;
    
    setTimeout(() => {
      showBubble.value = false;
    }, 3000);
  }
};

// Watch for state changes
watch(() => props.state.current, (newState, oldState) => {
  if (newState === 'idle' && oldState !== 'idle' && props.hasAvailableTutorials) {
    // Show hint after returning to idle state
    setTimeout(() => {
      showHint();
    }, 1000);
  }
});

// Lifecycle
onMounted(() => {
  // Show initial hint if tutorials are available
  if (props.hasAvailableTutorials) {
    setTimeout(() => {
      showHint();
    }, 3000);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mascot-display", { 'mascot-clickable': _ctx.hasAvailableTutorials }]),
    style: _normalizeStyle(mascotStyles.value),
    onClick: handleClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: currentMascotImage.value,
        alt: `PecTutor mascot in ${_ctx.state.current} state`,
        class: _normalizeClass(["mascot-image", animationClass.value]),
        onError: handleImageError
      }, null, 42, _hoisted_2),
      (_ctx.hasAvailableTutorials && _ctx.state.current === 'idle')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (showBubble.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["speech-bubble", `bubble-${bubbleType.value}`])
        }, _toDisplayString(bubbleText.value), 3))
      : _createCommentVNode("", true)
  ], 6))
}
}

})